import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import DeleteIcon from "@mui/icons-material/Delete";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import FlightLandIcon from "@mui/icons-material/FlightLand";

import "../App.css";
import AirportAutocomplete from "./AirportAutocomplete";
// import PassengerSelector from "./PassengerSelector";
import { Typography } from "@mui/material";
import DatePicker from "./DatePicker";
// import Luggage from "./Luggage";

const RE = /^[0-9\b]+$/;

function Leg({
  tabSelected,
  leg,
  updateLeg,
  removeLeg,
  removeDisabled,
  errors,
}) {
  return (
    <>
      <div className="saj-flight-content">
        <Grid container spacing={1} sx={{ padding: 1 }}>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <AirportAutocomplete
              label="Origen"
              error={errors?.from}
              onChange={(newValue) => updateLeg({ ...leg, from: newValue })}
              adornment={<FlightTakeoffIcon />}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <AirportAutocomplete
              label="Destino"
              error={errors?.to}
              onChange={(newValue) => updateLeg({ ...leg, to: newValue })}
              adornment={<FlightLandIcon />}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3} sx={{ display: "flex" }}>
            <DatePicker
              placeholder="Ida"
              value={leg.dateFrom}
              onChange={(newValue) => updateLeg({ ...leg, dateFrom: newValue })}
              error={errors?.dateFrom}
              sx={{
                borderRight: "1px solid rgba(0, 0, 0, 0.42)",
                "& .MuiInputBase-root, & .MuiInputBase-root.MuiFilledInput-root.Mui-focused, & .MuiInputBase-root.MuiFilledInput-root:hover":
                  {
                    borderBottomRightRadius:
                      tabSelected !== 0 ? "0!important" : 8,
                    borderTopRightRadius: tabSelected !== 0 ? "0!important" : 8,
                  },
              }}
            />
            {tabSelected === 1 && (
              <DatePicker
                placeholder="Vuelta"
                value={leg.dateTo}
                onChange={(newValue) => updateLeg({ ...leg, dateTo: newValue })}
                error={errors?.dateTo}
                minDate={leg.dateFrom}
                sx={{
                  "& .MuiInputBase-root, & .MuiInputBase-root.MuiFilledInput-root.Mui-focused, & .MuiInputBase-root.MuiFilledInput-root:hover":
                    {
                      borderBottomLeftRadius: "0!important",
                      borderTopLeftRadius: "0!important",
                    },
                }}
              />
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            {/* <PassengerSelector leg={leg} updateLeg={updateLeg} errors={errors} /> */}
            <div className="passenger-container">
              <Grid container justifyContent="center" alignItems="center">
                <Grid item>
                  <IconButton
                    disabled={leg.passengers <= 1}
                    onClick={() =>
                      updateLeg({ ...leg, passengers: leg.passengers * 1 - 1 })
                    }
                  >
                    <RemoveIcon />
                  </IconButton>
                </Grid>
                <Grid item sx={{ flex: 1 }}>
                  <Typography
                    variant="body1"
                    sx={{ width: 200, textAlign: "center" }}
                  >
                    <input
                      value={leg.passengers}
                      maxLength={3}
                      onChange={(e) => {
                        if (e.target.value === "" || RE.test(e.target.value)) {
                          updateLeg({ ...leg, passengers: e.target.value });
                        }
                      }}
                    />
                    {` Pasajero${leg.passengers > 1 ? "s" : ""}`}
                  </Typography>
                </Grid>
                <Grid item>
                  <IconButton
                    disabled={leg.passengers >= 999}
                    onClick={() =>
                      updateLeg({ ...leg, passengers: leg.passengers * 1 + 1 })
                    }
                  >
                    <AddIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </div>
          </Grid>
          {/* <Grid item xs={6} sm={2} lg={1}>
            <Luggage leg={leg} updateLeg={updateLeg} />
          </Grid> */}
        </Grid>
      </div>
      {tabSelected === 2 && (
        <div className="saj-flight-footer">
          <IconButton
            aria-label="delete"
            onClick={removeLeg}
            disabled={removeDisabled}
          >
            <DeleteIcon />
          </IconButton>
        </div>
      )}
    </>
  );
}

export default Leg;
